import { Loader2 } from './Icons';

export function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <Loader2 className="w-8 h-8 text-orange-400 animate-spin" />
    </div>
  );
}
